import { postJSON } from "../services/ajax";
import jwtDecode from "jwt-decode";

const expiration_threshold = 60000; // 1m

class AuthUser {
  constructor(token) {
    this._setToken(token);
  }

  _setToken({ access_token, refresh_token }) {
    this.token = access_token;
    this.refresh_token = refresh_token;
    const jwt = jwtDecode(access_token);
    this.expires = jwt.exp;
    this.uid = jwt.sub;
    this.claims = {
      role: jwt.roles[0] || "",
      locationId: jwt.locationId
    };
  }

  async getIdTokenResult() {
    const expires_at = this.expires * 1000;
    const now = Date.now();
    if (now >= expires_at - expiration_threshold) {
      const token = await postJSON("/api/v1/auth/token", {
        grant_type: "refresh_token",
        refresh_token: this.refresh_token
      });
      this._setToken(token);
    }
    const { token, claims, uid, expires } = this;
    return {
      token,
      claims,
      uid,
      expires
    };
  }
}

class AuthService {
  constructor() {
    this._user = null;
  }

  _authenticate(token) {
    window.sessionStorage.setItem("connect_tes_token", JSON.stringify(token));
    this._user = new AuthUser(token);
    this._onAuthStateChanged && this._onAuthStateChanged(this._user);
  }

  async signInWithEmailAndPassword(email, password) {
    const token = await postJSON("/api/v1/auth/token", {
      username: email,
      password
    });
    this._authenticate(token);
    return this._user;
  }

  async signOut() {
    window.sessionStorage.removeItem("connect_tes_token");
    this._onAuthStateChanged && this._onAuthStateChanged(null);
  }

  onAuthStateChanged(cb) {
    this._onAuthStateChanged = cb;

    setTimeout(() => {
      const raw_token = window.sessionStorage.getItem("connect_tes_token");
      if (raw_token) {
        const token = JSON.parse(raw_token);
        this._authenticate(token);
      } else {
        cb(null);
      }
    }, 0);

    return () => {
      this._onAuthStateChanged = null;
    };
  }
}

const _auth = new AuthService();

export const doSignIn = async (email, password) =>
  await _auth.signInWithEmailAndPassword(email, password);
export const doSignOut = async () => await _auth.signOut();
export const auth = _auth;



// WEBPACK FOOTER //
// ./src/security/auth.js